import CheckCircle from "@untitled-ui/icons-react/build/esm/CheckCircle";
import styled from "styled-components";
import TextSectionBg from "../../../../assets/images/text-section0.png";

// #region CONSTANTS
const INFO_SECTIONS = [
    {
        id: "operational-foundation",
        title: "Run every store and supplier in one BOtag account",
        description:
            "All plans include the operational foundation needed to manage product, order, stock and sales flows across your retail business.",
        subtitle: "Included in every plan",
        items: [
            "Unlimited stores",
            "Unlimited suppliers",
            "AI 24/7 employee - nanaBO",
            "Supplier/POS product mapping",
            "Product, order, stock and sales data flows",
            "Multiple authorized users",
            "Supported POS, ERP and ecommerce connections"
        ]
    },
    {
        id: "buying-intelligence",
        title: "Add Buying Intelligence",
        description: "Receive a complete seasonal buying recommendation for a selected brand and season.",
        subtitle: "Each complete report includes:",
        items: [
            "Historical sales and sell-through analysis",
            "Budget, category, size and color recommendations",
            "Supplier-meeting preparation",
            "Post-order review after the final order is uploaded"
        ]
    }
];

const DISCLAIMER =
    "Prices exclude VAT. Custom integrations and customer-specific development may be charged separately.";
// #endregion CONSTANTS

// #region SCOPED CSS
const StyledInfoCard = styled.div`
    background:
        url(${TextSectionBg}) center / contain no-repeat,
        linear-gradient(-17deg, rgba(20, 25, 34, 0) 0%, rgba(20, 25, 34, 0.2) 100%),
        linear-gradient(180deg, rgba(20, 25, 34, 0) 0%, rgba(20, 25, 34, 1) 100%);
    padding: 33px;
    display: flex;
    flex-direction: column;
    gap: 33px;
    justify-content: flex-end;
    flex-shrink: 0;
    width: 462px;

    .info-card-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
    }
    .info-section {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .section-title {
        color: #ffffff;
        font-size: 20px;
        letter-spacing: -0.015em;
        font-weight: 700;
    }
    .section-description {
        color: #ffffff;
        font-size: 14px;
        letter-spacing: -0.015em;
        font-weight: 400;
    }
    .section-subtitle {
        color: #ffffff;
        font-size: 14px;
        letter-spacing: -0.015em;
        font-weight: 700;
    }
    .bullet-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .bullet-item {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
    }
    .bullet-icon {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        color: var(--Buttons-All-Platforms-Chips, #006d00);
    }
    .bullet-text {
        color: #d1d1d1;
        font-size: 14px;
        line-height: 21px;
        font-weight: 400;
        flex: 1;
    }
    .disclaimer-text {
        color: #ffffff;
        font-size: 12px;
        letter-spacing: -0.015em;
        font-weight: 400;
    }
`;
// #endregion SCOPED CSS

export default function BillingInfoCard() {
    return (
        <StyledInfoCard>
            <div className="info-card-content">
                {INFO_SECTIONS.map(section => (
                    <SectionInfo key={section.id} {...section} />
                ))}

                <div className="disclaimer-text">{DISCLAIMER}</div>
            </div>
        </StyledInfoCard>
    );
}

// #region SMALL COMPONENTS
function SectionInfo({ title, description, subtitle, items }) {
    return (
        <div className="info-section">
            <div className="section-title">{title}</div>
            <div className="section-description">{description}</div>
            <div className="section-subtitle">{subtitle}</div>

            <div className="bullet-list">
                {items.map(item => (
                    <div className="bullet-item" key={item}>
                        <CheckCircle className="bullet-icon" />
                        <div className="bullet-text">{item}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
// #endregion SMALL COMPONENTS
